import Auth from "@aws-amplify/auth";
import type { CognitoUser } from "amazon-cognito-identity-js";

type AuthenticatedUser = CognitoUser & {
  attributes?: {
    email?: string;
    sub?: string;
    [key: string]: string | boolean | undefined;
  };
};

export class UserNotAuthenticated extends Error {
  name = "UserNotAuthenticated";
  constructor() {
    super("The user is not authenticated");
  }
}

// will load from local storage so
// not guaranteed to return valid token
export const getCurrentAuthenticatedUser =
  async (): Promise<AuthenticatedUser> => {
    try {
      return await Auth.currentAuthenticatedUser();
    } catch (e: unknown) {
      if (e === "The user is not authenticated") {
        throw new UserNotAuthenticated();
      }
      throw e;
    }
  };
